import { Operator } from './operator';

export class OperatorGroup {
  constructor(
    public hash?: string,
    public name?: string,
    public workingModelGroupHash?: string,
    public workingModelGroupName?: string,
    public operators?: Operator[],
  ) { }

  clone() {
    return new OperatorGroup(
      this.hash,
      this.name,
      this.workingModelGroupHash,
      this.workingModelGroupName,
      this.operators,
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operator-group.ts